/* ============================================================
   Sinezy — Drawer panier : logique cadeau automatique + timer + upsell + promo.

   Cadeau automatique (« Protocole de 21 jours ») :
   - Si le produit déclencheur (Sinezy Confort, une variante quelconque) est dans
     le panier et que le cadeau n'y est pas → on l'ajoute (quantité 1).
   - Si le déclencheur est retiré → on retire le cadeau.
   - Si le client retire le cadeau à la main (poubelle) → il reste retiré pour le
     moment, mais réapparaît à la réouverture du drawer OU après tout autre
     ajout/suppression tant que le déclencheur est présent.
   - Le cadeau n'a pas de sélecteur de quantité ; s'il passe à une quantité ≠ 1
     par un autre biais, on le ramène à 1.

   La détection « retrait manuel du cadeau » se fait par comparaison d'état
   (avant/après) car l'événement de suppression de Dawn ne transmet pas de
   variantId fiable. Le prix réel à 0 € en caisse dépend d'une remise automatique
   « Achetez X, obtenez Y » (−100 %) à créer côté admin — sans code ici.
   ============================================================ */
(function () {
  if (window.__sinezyCartGiftLoaded) return;
  window.__sinezyCartGiftLoaded = true;

  var busy = false;
  var giftDismissed = false;
  var prevHasGift = false;
  var prevHasTrigger = false;
  var configCache = null;

  function routeAdd() { return (window.routes && window.routes.cart_add_url) || '/cart/add.js'; }
  function routeUpdate() { return (window.routes && window.routes.cart_update_url) || '/cart/update.js'; }

  function getConfig() {
    if (configCache) return configCache;
    var el = document.querySelector('[data-sz-cart-config]');
    if (!el) return null;
    try {
      var c = JSON.parse(el.textContent);
      configCache = c;
      return c;
    } catch (e) { return null; }
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function postCart(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (r) { return r.json(); });
  }

  /* Remplace le contenu du drawer + la pastille panier à partir des sections
     rendues par l'API Section Rendering (mêmes sélecteurs que Dawn). */
  function applySections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var newInner = doc.querySelector('.drawer__inner');
      var curInner = document.querySelector('cart-drawer .drawer__inner');
      if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
    }
    if (sections['cart-icon-bubble']) {
      var d2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var newBubble = d2.querySelector('.shopify-section') || d2.body;
      var curBubble = document.getElementById('cart-icon-bubble');
      if (newBubble && curBubble) curBubble.innerHTML = newBubble.innerHTML;
    }
  }

  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function addVariant(variantId, quantity) {
    return postCart(routeAdd(), {
      id: variantId,
      quantity: quantity || 1,
      sections: SECTIONS,
      sections_url: window.location.pathname,
    });
  }

  /* Fixe la quantité d'une variante (0 = retrait). On passe par /cart/update.js
     et son map `updates` (clé = variant id), et NON /cart/change.js : ce dernier
     exige un `id` de type chaîne (\d+ ou \d+:hash) et renvoie 400 sur un id
     numérique, ce qui empêchait le retrait automatique du cadeau. */
  function changeVariant(variantId, quantity) {
    var updates = {};
    updates[variantId] = quantity;
    return postCart(routeUpdate(), {
      updates: updates,
      sections: SECTIONS,
      sections_url: window.location.pathname,
    });
  }

  function hasProduct(items, pid) {
    for (var i = 0; i < items.length; i++) { if (items[i].product_id === pid) return true; }
    return false;
  }
  function findGiftLine(items, pid) {
    for (var i = 0; i < items.length; i++) { if (items[i].product_id === pid) return items[i]; }
    return null;
  }

  /* Réconciliation centrale. options.fromOpen = ouverture du drawer. */
  function reconcile(options) {
    options = options || {};
    var cfg = getConfig();
    if (!cfg || !cfg.triggerProductId || !cfg.giftProductId || !cfg.giftVariantId) return Promise.resolve();
    if (busy) return Promise.resolve();
    busy = true;

    return fetchCart()
      .then(function (cart) {
        var items = cart.items || [];
        var hasTrigger = hasProduct(items, cfg.triggerProductId);
        var giftLine = findGiftLine(items, cfg.giftProductId);
        var hasGift = !!giftLine;

        if (options.fromOpen) {
          giftDismissed = false;
        } else {
          // Retrait manuel du cadeau : présent avant, absent maintenant, déclencheur toujours là.
          if (prevHasGift && !hasGift && hasTrigger) {
            giftDismissed = true;
            prevHasGift = hasGift;
            prevHasTrigger = hasTrigger;
            return null; // on le laisse retiré pour l'instant
          }
          // Toute autre mise à jour lève la mise en pause.
          giftDismissed = false;
        }

        var action = null;
        if (hasTrigger && !hasGift && !giftDismissed) {
          action = addVariant(cfg.giftVariantId, 1);
        } else if (!hasTrigger && hasGift) {
          action = changeVariant(cfg.giftVariantId, 0);
        } else if (hasGift && giftLine.quantity !== 1) {
          action = changeVariant(cfg.giftVariantId, 1);
        }

        if (!action) return null;
        return action.then(function (res) {
          if (res && res.sections) applySections(res.sections);
          return res;
        });
      })
      .then(function () {
        // Rafraîchit l'état de référence après une éventuelle mutation.
        return fetchCart().then(function (cart2) {
          var items2 = cart2.items || [];
          prevHasGift = hasProduct(items2, getConfig().giftProductId);
          prevHasTrigger = hasProduct(items2, getConfig().triggerProductId);
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  /* ---- Ouverture du drawer : réapparition du cadeau ---- */
  function watchDrawerOpen() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return;
    var wasActive = cd.classList.contains('active');
    new MutationObserver(function () {
      var active = cd.classList.contains('active');
      if (active && !wasActive) reconcile({ fromOpen: true });
      wasActive = active;
    }).observe(cd, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---- Accessoires suggérés : bouton + ---- */
  function initUpsellClicks() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-sz-upsell-add]') : null;
      if (!btn) return;
      e.preventDefault();
      var vid = btn.getAttribute('data-variant-id');
      if (!vid || btn.disabled) return;
      btn.disabled = true;
      addVariant(vid, 1)
        .then(function (res) { if (res && res.sections) applySections(res.sections); })
        .then(function () { return reconcile({}); })
        .catch(function () {})
        .then(function () { btn.disabled = false; });
    });
  }

  /* ---- Code promo : applique via /discount/CODE puis retour au panier ---- */
  function initPromo() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest ? e.target.closest('[data-sz-promo]') : null;
      if (!form) return;
      e.preventDefault();
      var input = form.querySelector('input[name="discount"]');
      var code = input ? input.value.trim() : '';
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    });
  }

  /* ---- Compte à rebours de réservation (cosmétique, persistant en session) ---- */
  function initTimer() {
    setInterval(function () {
      var el = document.querySelector('.sz-cd-timer');
      if (!el) return;
      var minutes = parseInt(el.getAttribute('data-minutes'), 10) || 10;
      var start = sessionStorage.getItem('szCartTimerStart');
      if (!start) { start = String(Date.now()); sessionStorage.setItem('szCartTimerStart', start); }
      var remaining = minutes * 60 - Math.floor((Date.now() - parseInt(start, 10)) / 1000);
      if (remaining < 0) { sessionStorage.setItem('szCartTimerStart', String(Date.now())); remaining = minutes * 60; }
      var m = String(Math.floor(remaining / 60));
      var s = String(remaining % 60);
      if (m.length < 2) m = '0' + m;
      if (s.length < 2) s = '0' + s;
      el.textContent = m + ':' + s;
    }, 1000);
  }

  /* ---- Préservation du scroll ----
     Changer une quantité fait re-render tout le contenu du drawer (Dawn remplace
     .drawer__inner), ce qui remet le scroll en haut (« sursaut »). On mémorise la
     position AVANT la mutation (au clic sur +/- / poubelle / +accessoire) et on la
     restaure après le re-render. */
  var szSavedScroll = 0;
  function szScroller() { return document.querySelector('.sz-cd-scroll'); }
  function szSaveScroll() { var s = szScroller(); if (s) szSavedScroll = s.scrollTop; }
  function szRestoreScroll() { var s = szScroller(); if (s && szSavedScroll > 0) s.scrollTop = szSavedScroll; }
  function initScrollPreserve() {
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.sz-cd-qty, .sz-cd-remove, [data-sz-upsell-add]')) szSaveScroll();
    }, true);
  }

  /* ---- Écoute des mises à jour panier de Dawn ---- */
  function initCartUpdateSub() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'sinezy-cart') return;
        reconcile({});
        // Restaure la position de scroll après les re-renders successifs.
        requestAnimationFrame(szRestoreScroll);
        setTimeout(szRestoreScroll, 80);
        setTimeout(szRestoreScroll, 250);
      });
    }
  }

  /* ---- Synchronise la classe is-empty du <cart-drawer> ----
     renderContents() de Dawn remplace le contenu de #CartDrawer mais ne met pas
     à jour la classe is-empty du wrapper. Restée à tort, elle déclenche la règle
     Dawn `cart-drawer.is-empty .drawer__inner{display:grid}` qui effondre la zone
     d'articles. On resynchronise selon la présence réelle de lignes produit. */
  function syncEmptyClass() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return;
    var hasItems = !!cd.querySelector('#CartDrawer-CartItems .sz-cd-item');
    cd.classList.toggle('is-empty', !hasItems);
  }
  function watchEmptyClass() {
    var host = document.getElementById('CartDrawer');
    if (!host) return;
    // On observe le contenu interne (childList/subtree), pas les attributs du
    // wrapper : basculer la classe du wrapper (parent) ne relance pas l'observer.
    new MutationObserver(syncEmptyClass).observe(host, { childList: true, subtree: true });
    syncEmptyClass();
  }

  function init() {
    watchEmptyClass();
    watchDrawerOpen();
    initUpsellClicks();
    initPromo();
    initTimer();
    initScrollPreserve();
    initCartUpdateSub();
    // Réconciliation initiale : ajoute le cadeau si le déclencheur est déjà présent.
    reconcile({});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
